import React from 'react';

const DisResult = () => {
  return <div>DisResult</div>;
};

export default DisResult;
